import { clsx } from 'clsx';
import { FC } from 'react';

import { Image } from '@repo/ui/Image';
import type { ImageBreakpointSrcSetSizes } from '@repo/ui/Image';
interface Props {
  src: string;
  alt: string;
  width?: number;
  imagePriority?: boolean;
  className?: string;
  'data-testid'?: string;
}

const IMAGE_ASPECT_RATIO = 16 / 9;

const IMAGE_BREAKPOINTS: ImageBreakpointSrcSetSizes = [
  ['default', 320],
  ['md', 300],
  ['lg', 360],
];

export const ProductImage: FC<Props> = ({
  src,
  alt,
  width = 320,
  imagePriority,
  className,
  'data-testid': dataTestId,
}) => {
  const height = Math.round(width / IMAGE_ASPECT_RATIO);
  return (
    <Image
      src={src}
      width={width}
      height={height}
      breakpoints={IMAGE_BREAKPOINTS}
      alt={alt}
      className={clsx('relative block aspect-video h-auto w-full bg-(image:--gradient-product-placeholder)', className)}
      data-testid={dataTestId || 'ProductCard-component-image'}
      priority={imagePriority}
    />
  );
};
